import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, ApiError, type EntryDetail } from "../api";

/** Uploads a file and opens it for review (or the existing entry if it's a duplicate). */
export function useUpload() {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const upload = async (file: File) => {
    setBusy(true);
    setError(null);
    try {
      const entry = await api.upload<EntryDetail>(file);
      navigate(`/inbox/${entry.id}`);
    } catch (e) {
      if (e instanceof ApiError && e.status === 409 && e.details?.entryId) {
        navigate(`/inbox/${e.details.entryId}?duplicate=1`);
      } else {
        setError(e);
      }
    } finally {
      setBusy(false);
    }
  };
  return { upload, busy, error };
}
